// 预取「用户隔离 header 名」的单一事实源。
//
// app 侧（utils/axios 拦截）、boot 侧（packages/sw-prefetch 预热）、SW 侧
// （packages/sw-prefetch/src/prefetch-sw.ts 拦截去重）三处都要用同一个 header 名：页面/预热把
// user_id 塞进这个 header，SW 再从同名 header 读出来拼进 dedupKey。一旦漂移，SW 读不到塞进的
// header → dedupKey 永远 miss，预取去重整体失效。故抽到此中立文件做唯一真相，三侧都从这里取。
//
// 关键：该 header 纯前端自用，绝不送达后端 —— SW 在「转发页面请求」与「发出预热请求」之前都用
// stripUserHeader 把它删掉（见 prefetch-sw.ts）。配合 utils/axios 仅在 SW 已接管页面
// （navigator.serviceWorker.controller 非空、请求必被 SW 拦截）时才注入此 header，故跨域请求
// 到达后端时永远不含它 → 无需任何后端 CORS Access-Control-Allow-Headers 放行 → 免除「多服务
// 各自维护白名单、易漏配」的风险。名字取语义化的 x-user-id 仅为可读性，与后端 CORS 无关。
//
// 本文件必须零 import（纯字面量）：SW 走经典脚本约束、运行在无 localStorage/DOM 的 worker 作用域，
// esbuild 打包时把它内联进 SW/boot 产物，零 import 才不会牵连 ./storage、readUserId 等碰
// localStorage 的代码。与 constant/prefetch-shared.ts 同一范式。

export const USER_ID_HEADER = 'x-user-id'
